import { getOrderList } from 'model/order';
import { getUser } from 'model/user';
import OrderCancelSuccessRoute from './CancelSuccess';
import OrderDetailRoute from './Detail';
import OrderCancelATMRoute from './CancelATM';

export default store => ({
	path: 'order',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'Order',
			),
		onEnter: () => {
			store.dispatch(getOrderList());
			store.dispatch(getUser());
		},
	},
	childRoutes: [OrderCancelSuccessRoute(), OrderDetailRoute(store), OrderCancelATMRoute(store)],
});
